import React from 'react';

const AddTabModal = ({ newTabName, setNewTabName, handleAddTab, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[1000] backdrop-blur-sm">
      <div className="bg-white rounded-lg p-6 w-[400px] max-w-[90%] shadow-xl border border-gray-200 animate-fadeInUp">
        <h2 className="mt-0 mb-5 text-xl font-semibold border-b border-gray-100 pb-3">
          Create New Tab
        </h2>
        
        <div className="mb-4">
          <label htmlFor="tabName" className="block mb-1.5 font-medium text-sm">
            Tab Name:
          </label>
          <input
            type="text"
            id="tabName"
            value={newTabName}
            onChange={(e) => setNewTabName(e.target.value)}
            placeholder="Enter tab name"
            className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm transition-all bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:bg-white"
            required
          />
        </div>
        
        <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
          <button
            className="px-4 py-2 bg-gray-100 text-gray-600 rounded-md font-medium text-sm transition-all hover:bg-gray-200"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 bg-secondary text-white rounded-md font-medium text-sm transition-all ${
              !newTabName.trim() ? 'bg-secondary-light cursor-not-allowed' : 'hover:bg-secondary-dark'
            }`}
            onClick={handleAddTab}
            disabled={!newTabName.trim()}
          >
            Create Tab
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTabModal;